/**
 * What a URL names — SPEC_5 Decision 1: `/` and `/signin`, nothing else.
 *
 * *Rejected: the old route tree, one level each for a fund, a day and a wake.* There is one team
 * and one current trading day. A past day's evidence lives in the backend archive (SPEC_4), nobody
 * asked for a history browser, and today's run viewer answers "why did it decide that". Any other
 * path goes to `/`.
 */

import { Navigate, createBrowserRouter } from "react-router-dom";
import { App } from "./App";
import { SignIn } from "./pages/SignIn";
import { Console } from "./pages/Console";

export const router = createBrowserRouter([
  { path: "/signin", element: <SignIn /> },
  {
    path: "/",
    element: <App />,
    children: [{ index: true, element: <Console /> }],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
